import React, { Component } from 'react';
import { Button, Popconfirm, message } from 'antd';
import UpdateModal from './UpdateLicence';
import ComTable from '../ComTable';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';

class Licence extends Component {
    state = {
        data: [],
        config: [],
        pagination: {
            offset: 1,
            pageSize: 10,
        },
        loading: false,
    }

    componentDidMount() {
        const config = [{
            zh: '执照/许可证/证书名称',
            en: 'Licences/Certificates Name',
            key: 'licencesCertificates',
            width: 450,
        }, {
            zh: '获得证书日期',
            en: 'Certificate Date',
            key: 'certificateDate',
        }];
        this.setState({ config }, () => {
            this.loadData();
        });
    }

    loadData = () => {
        const { userId, isChinese } = this.props;
        const { pagination } = this.state;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.personal.queryVitaeLicencesCertificatesList,
            data: {
                userId,
                offset: current,
                limit: pageSize,
                type: isChinese ? 'CHINESE' : 'ENGLISH',
            },
            dataType: 'json',
            doneResult: res => {
                const { licencesCertificatesList = [], totalCount = 0 } = res;
                pagination.total = totalCount;

                this.setState({
                    pagination,
                    loading: false,
                    data: licencesCertificatesList,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    update = (record) => {
        this.ref.show(record);
    }

    delete = (row) => {
        const { vitaeLicencesCertificatesId } = row;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.personal.delVitaeLicencesCertificates,
            data: { vitaeLicencesCertificatesId },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({ loading: false }, () => {
                    this.loadData();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    handleTableChange = ({ pagination }) => {
        this.setState({ pagination }, () => {
            this.loadData();
        });
    }

    getOperate = () => {
        const { isChinese } = this.props;
        return {
            title: isChinese ? '操作' : 'Operation',
            key: 'operate',
            width: 80,
            render: (text, row) => {
                return (
                    <span>
                        <a onClick={() => this.update(row)}>修改</a>
                        {
                            isChinese ? 
                                <span>
                                    <span className="ant-divider" />
                                    <Popconfirm title="确定要删除吗?" onConfirm={() => this.delete(row)}>
                                        <a>删除</a>
                                    </Popconfirm>
                                </span>
                            :
                             null
                        }
                    </span>
                );
            }
        };
    }

    getDataSource = () => {
        const { data } = this.state;
        const { isChinese } = this.props;
        const dataSource = data.map((item, index) => {
            const {
                licencesCertificatesName,
                licencesCertificatesNameEnglish,
                licencesGcpChinese,
                licencesGcpEnglish,
                licencesOtherChinese,
                licencesOtherEnglish,
                certificateDate,
            } = item;
            const licencesGcp = isChinese ? licencesGcpChinese : licencesGcpEnglish;
            const licencesOther = isChinese ? licencesOtherChinese : licencesOtherEnglish;
            const Gcp_Other = licencesOther || licencesGcp;
            return {
                index: index + 1,
                ...item,
                licencesCertificates: `${isChinese ? licencesCertificatesName : licencesCertificatesNameEnglish}${Gcp_Other ? `(${Gcp_Other})` : ''}`,
                certificateDate: certificateDate.slice(0, 7),
            }
        });
        return dataSource;
    }

    render() {
        const { userId, canEdit, isChinese } = this.props;
        const { data, config, loading, pagination } = this.state;
        const result = config.map(item => {
            if (isChinese) {
                item.title = item.zh;
            } else {
                item.title = item.en;
            }
            return item;
        });
        canEdit && result.push(this.getOperate());
        return (
            <div>
                { canEdit && isChinese && <Button type="primary" onClick={() => this.update()}>新增</Button> }
                <div style={{ marginTop: 20 }}>
                    <ComTable
                        data={data}
                        config={result}
                        loading={loading}
                        pagination={pagination}
                        getDataSource={this.getDataSource}
                        onChange={(params) => this.handleTableChange(params)}
                    />
                </div>
                <UpdateModal ref={el => this.ref = el} userId={userId} isChinese={isChinese} loadData={this.loadData} />
            </div>
        );
    }
}

export default Licence;


// WEBPACK FOOTER //
// ./src/components/common/curriculumVitae/Licence.js